<template>
  <i class="icon icon--error" v-if="show" v-b-tooltip.hover :title="warningText"></i>
</template>

<script>
  export default {
    name: 'printer-warning-flags',
    props: ['printer'],
    computed: {
      show() {
        return this.printer.door_open ||
          this.printer.no_filament ||
          this.printer.filament_clogged ||
          this.printer.bed_not_clear;
      },
      warningText() {
        let warnings = [];
        if (this.printer.door_open) {
          warnings.push(this.$t('printers.item.flags.doorOpen'));
        }
        if (this.printer.no_filament) {
          warnings.push(this.$t('printers.item.flags.noFilament'));
        }
        if (this.printer.filament_clogged) {
          warnings.push(this.$t('printers.item.flags.filamentClogged'));
        }
        if (this.printer.bed_not_clear) {
          warnings.push(this.$t('printers.item.flags.bedNotClear'));
        }

        return warnings.join(', ');
      }
    }
  }
</script>
